import { render, staticRenderFns } from "./DlvPL.vue?vue&type=template&id=629d48b0"
import script from "./DlvPL.vue?vue&type=script&lang=js"
export * from "./DlvPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports